import { Action, createReducer, on } from '@ngrx/store';
import { authCheck, authCheckSuccess, authLogoutFailed, authLogoutSuccess } from './auth.actions';
import { AuthState } from './auth.state';

export const initialState: AuthState = {
  isAuthenticated: false,
  token: undefined,
  isLoading: false
};

const logout = (state: AuthState): AuthState => ({ ...state, isAuthenticated: false, token: undefined });

const reducer = createReducer(
  initialState,
  on(authCheckSuccess, (state, action) => ({
    ...state,
    isAuthenticated: action.isAuthenticated,
    token: action.token,
    isLoading: false
  })),
  on(authLogoutSuccess, logout),
  on(authLogoutFailed, logout),
  on(authCheck, (state, action) => ({ ...state, isLoading: true }))
);

export function authReducer(state: AuthState | undefined, action: Action): AuthState {
  return reducer(state, action);
}
